module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "cover"
  }, [_c('a', {
    attrs: {
      "id": "pXII"
    }
  }), _c('a', {
    attrs: {
      "id": "pXIII"
    }
  }), _c('img', {
    attrs: {
      "alt": "Hannibal",
      "src": "images/tree1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("N"), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("OTE")]), _vm._v(" We know of at least six children born to Hamilcar Barca. The first three were girls and these anonymous daughters were married to form political and military alliances. His sons, ‘the lion cubs’ reared to destroy Rome (Valerius Maximus 9.3.2 claims four sons), fought together in the Second Punic War, as did his grandson Hanno (who commanded the left wing of cavalry at Cannae according to Appian, "), _c('i', [_vm._v("Hann.")]), _vm._v(" 20). Except for Hannibal’s, the ages are largely hypothetical. Cornelius Nepos tells us that Hamilcar was ‘very young’ when he took command in Sicily. However, by that time he was already the father of four children so he could not have been that young – the estimate used here places him in his late twenties at the time of Hannibal’s birth in 247 (Lancel, 1999, 9). Hannibal’s niece was married to Masinissa’s uncle; she was the daughter of one of his sisters, but which one is unclear. For the family history see Hoyos, 2005, 21–23.")]), _vm._v(" "), _c('p', {
    staticClass: "caption-source"
  }, [_vm._v("* All dates in "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("BCE")]), _vm._v(".")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-079831d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/family_tree.vue
// module id = 81
// module chunks = 0